import { useState, useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useGallery = () => {
  const { api, userID } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [galleryItems, setGalleryItems] = useState([]);
  const [currentDir, setCurrentDir] = useState("gallery");
  const [folderStack, setFolderStack] = useState(["gallery"]);

  const typeFrom = (item) => {
    if (item?.fileType) return item.fileType.toUpperCase();

    const ext = (item?.fileName || "")
      .split(".")
      .pop()
      ?.toLowerCase();

    if (
      ["jpg", "jpeg", "png", "webp", "gif", "bmp", "svg"].includes(ext)
    )
      return "IMAGE";

    if (
      ["mp4", "webm", "ogg", "mov", "m4v"].includes(ext)
    )
      return "VIDEO";

    if (
      ["pdf", "txt", "doc", "docx", "xls", "xlsx", "csv"].includes(ext)
    )
      return "DOCUMENT";

    return "FILE";
  };

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(endpoint, body);
      return response?.data;
    },
    [api]
  );

  // Fetch Media Gallery
  const getMediaGallery = async (
    directory = currentDir
  ) => {
    try {
      setLoading(true);

      const data = await postRequest(
        "/Order/v1.0/getMediaGallery",
        {
          userid: userID,
          directory,
        }
      );

      if (data?.responseCode === "00") {
        const normalized = (
          data?.response || []
        ).map((item) => ({
          galleryId: item.galleryId,
          fileName: item.fileName,
          fileUrl: item.fileUrl || "",
          fileType: typeFrom(item),
        }));

        setGalleryItems(normalized);
      } else {
        setGalleryItems([]);
      }

      return data;
    } catch (error) {
      console.error(
        "Media Gallery Error:",
        error?.response?.data || error
      );

      setGalleryItems([]);

      return null;
    } finally {
      setLoading(false);
    }
  };

  // Open Folder
  const openFolder = async (folderName) => {
    const newStack = [...folderStack, folderName];

    setFolderStack(newStack);
    setCurrentDir(folderName);

    await getMediaGallery(folderName);
  };

  // Go Back
  const goBack = async () => {
    if (folderStack.length <= 1) return;

    const newStack = folderStack.slice(0, -1);
    const previousDir =
      newStack[newStack.length - 1];

    setFolderStack(newStack);
    setCurrentDir(previousDir);

    await getMediaGallery(previousDir);
  };

  // Go To Breadcrumb
  const goToCrumb = async (index) => {
    const newStack = folderStack.slice(
      0,
      index + 1
    );

    const dir = newStack[newStack.length - 1];

    setFolderStack(newStack);
    setCurrentDir(dir);

    await getMediaGallery(dir);
  };

  return {
    loading,
    galleryItems,
    currentDir,
    folderStack,
    getMediaGallery,
    openFolder,
    goBack,
    goToCrumb,
  };
};

export default useGallery;